import owd from 'owd/owd';
import scrollbar from 'owd/utils/scrollbar';
import EventEmitter from 'eventemitter2';

export default class ScrollbarPlaceholder extends owd.Module {
    constructor(app) {
        super(app);
        
        this.currentHeight = 0;
        this.allowScroll = true;
        this.available = false;

        // if (scrollbar.width() > 0 || !Modernizr.touch) {
        //     this.available = true;
        //     this.createPlaceholder();
        // } else {
            $('html').addClass('no-scrollbar-placeholder');
        // }
        
        this.bind();
        this.eventEmitter = new EventEmitter();
        this.eventEmitter.setMaxListeners(200);
    }

    createPlaceholder() {
        this.$placeholder = $('<div></div>');
        this.app.dom.$body.append(this.$placeholder);
    }

    isAvailable() {
        return this.available;
    }

    bind() {
        this.app.dom.$window.on('scroll', () => {
            if (this.available) {
                this.emit('scroll', this.app.dom.$window.scrollTop());
            }
        });

        this.app.dom.$window.on('pageOutDone', () => {
            this.clear();
        });

        this.app.dom.$body.on('mousewheel touchstart touchmove', (e) => {
            if (!this.allowScroll) {
                e.preventDefault();
            }
        });
    }

    enableScroll() {
        this.allowScroll = true;
    }

    disableScroll() {
        this.allowScroll = false;
    }

    getScroll() {
        if (this.available) {
            return this.app.dom.$window.scrollTop();
        }

        return 0;
    }

    setScroll(value) {
        if (this.available) {
            this.app.dom.$window.scrollTop(value);
        }
        return this;
    }

    setLength(height) {
        if (this.available && this.currentHeight !== height) {
            this.$placeholder.css({
                height: height
            });
            this.currentHeight = height;
        }

        return this;
    }

    clear() {
        if (this.available) {
            this.setLength('');
            this.setScroll(0);
        }

        return this;
    }

    emit(...args) {
        this.eventEmitter.emit.apply(this.eventEmitter, args);
        return this;
    }

    on(...args) {
        this.eventEmitter.on.apply(this.eventEmitter, args);
        return this;
    }

    off(...args) {
        this.eventEmitter.off.apply(this.eventEmitter, args);
        return this;
    }
}